(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DiadaoAccordion = function () {
    function DiadaoAccordion() {
        _classCallCheck(this, DiadaoAccordion);
    }

    _createClass(DiadaoAccordion, null, [{
        key: 'init',
        value: function init() {
            this.load();
            $('.lp-overlay').click(this.toggle);
            // $('.lp-overlay:first-child').addClass('open-accordion');
        }
    }, {
        key: 'load',
        value: function load() {
            var $count = 0;
            $('.lp-overlay').each(function () {
                if ($count == 0) {
                    $(this).addClass('open-accordion');
                }
                $count++;
                $(this).find('.lp-overlay__visible').append('<div class="icon-accordion icon-diadao-arrow-right-small"></div>');
            });
        }
    }, {
        key: 'toggle',
        value: function toggle() {

            var $this = $(this);
            $('.lp-overlay').each(function () {
                if ($(this).html() != $this.html()) {
                    $(this).removeClass('open-accordion');
                }
            });
            if ($this.hasClass('open-accordion')) {
                $this.removeClass('open-accordion');
            } else {
                $this.addClass('open-accordion');
                $('html, body').animate({
                    scrollTop: $this.offset().top - 65
                });
            }
        }
    }]);

    return DiadaoAccordion;
}();

exports.default = DiadaoAccordion;

},{}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DiadaoAnimation = function () {
    function DiadaoAnimation() {
        _classCallCheck(this, DiadaoAnimation);
    }

    _createClass(DiadaoAnimation, null, [{
        key: 'init',
        value: function init() {
            $(document).scroll(this.verfifyToScroll);
            this.verfifyToScroll();
        }
    }, {
        key: 'verfifyToScroll',
        value: function verfifyToScroll() {
            $('.animate__fade-in').each(function () {
                var $this = $(this);
                if ($this.offset().top < $(document).scrollTop() + $(window).height() / 1.25) {
                    $(this).addClass('done');
                }
            });
        }
    }]);

    return DiadaoAnimation;
}();

exports.default = DiadaoAnimation;

},{}],3:[function(require,module,exports){
"use strict";

var _links = require("./links");

var _links2 = _interopRequireDefault(_links);

var _object = require("./object");

var _object2 = _interopRequireDefault(_object);

var _common = require("./common");

var _common2 = _interopRequireDefault(_common);

var _slick = require("./slick");

var _slick2 = _interopRequireDefault(_slick);

var _forms = require("./forms");

var _forms2 = _interopRequireDefault(_forms);

var _effects = require("./effects");

var _effects2 = _interopRequireDefault(_effects);

var _fancybox = require("./fancybox");

var _fancybox2 = _interopRequireDefault(_fancybox);

var _offer = require("./offer");

var _offer2 = _interopRequireDefault(_offer);

var _accordion = require("./accordion");

var _accordion2 = _interopRequireDefault(_accordion);

var _overlay = require("./overlay");

var _overlay2 = _interopRequireDefault(_overlay);

var _offerhighlight = require("./offerhighlight");

var _offerhighlight2 = _interopRequireDefault(_offerhighlight);

var _animation = require("./animation");

var _animation2 = _interopRequireDefault(_animation);

var _video = require("./video");

var _video2 = _interopRequireDefault(_video);

var _map = require("./map");

var _map2 = _interopRequireDefault(_map);

var _sliderRevolution = require("./slider-revolution");

var _sliderRevolution2 = _interopRequireDefault(_sliderRevolution);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

jQuery(document).ready(function () {
  window.$ = jQuery;
  $(window).on("load", function () {
    _links2.default.init();
    _object2.default.init();
    _common2.default.init();
    _slick2.default.init();
    _forms2.default.init();
    _effects2.default.init();
    _fancybox2.default.init();
    _offer2.default.init();
    _accordion2.default.init();
    _overlay2.default.init();
    _offerhighlight2.default.init();
    _animation2.default.init();
    _video2.default.init();
    _map2.default.init();
    _sliderRevolution2.default.init();
  });
});

},{"./accordion":1,"./animation":2,"./common":4,"./effects":5,"./fancybox":6,"./forms":7,"./links":8,"./map":9,"./object":10,"./offer":11,"./offerhighlight":12,"./overlay":13,"./slick":14,"./slider-revolution":15,"./video":16}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DiadaoCommon = function () {
    function DiadaoCommon() {
        _classCallCheck(this, DiadaoCommon);
    }

    _createClass(DiadaoCommon, null, [{
        key: 'init',
        value: function init() {
            this.load();
        }
    }, {
        key: 'load',
        value: function load() {
            this.addHeaderBookingButton();
            this.fixeHeader();
            this.addLangSelector();
            this.verifyHeaderSticky();

            var that = this;

            // $('.testimonial-item').bind('DOMSubtreeModified', function(e){
            //     // if(e.target.innerHTML.length > 0){
            //         that.sliderFixedHeight();
            //     // }
            // });

            $(window).on('resize', function () {
                that.verifyHeaderSticky();
            });
        }

        // static sliderFixedHeight(){
        //     let $testimonial = $('.mk-testimonial');
        //
        //     if($testimonial.length){
        //         if($(window).width() < 769 ){
        //             let $active_slide = $testimonial.find('.flex-active-slide');
        //             let $content_list = $testimonial.find('ul.mk-flex-slides');
        //             let $height_to_fix = $active_slide.outerHeight() + 50;
        //
        //             console.log($height_to_fix);
        //
        //             $content_list.animate(
        //                 {height: $height_to_fix + 'px'},
        //                 500
        //             );
        //         }
        //     }
        // }

    }, {
        key: 'addHeaderBookingButton',
        value: function addHeaderBookingButton() {

            var $button = $('.header__right-box');
            $button.remove();
            $('.mk-header-holder').append($button);
        }
    }, {
        key: 'fixeHeader',
        value: function fixeHeader() {
            $('.mk-header-holder').attr('style', 'position: fixed!important');
        }
    }, {
        key: 'addLangSelector',
        value: function addLangSelector() {
            // if($(window).width() < 1025){
            var $menu = $('#menu-menu-principal-1');
            var $langSelector = $('.lang-content').html();
            $menu.append('<li class="lang-selector">' + $langSelector + '</li>');
            // }
        }
    }, {
        key: 'verifyHeaderSticky',
        value: function verifyHeaderSticky() {
            if (!$('.rev_slider_wrapper').length) {
                $('.mk-header').addClass('a-sticky');
                $('.theme-content').addClass('padding');
            } else {
                if ($(window).width() > 1024) {
                    $(document).scroll(this.changeHeaderSticky);
                    this.changeHeaderSticky();
                }
            }
        }
    }, {
        key: 'changeHeaderSticky',
        value: function changeHeaderSticky() {
            var $document_position = $(document).scrollTop();
            if ($document_position > 100) {
                $('.mk-header').addClass('a-sticky');
            } else {
                $('.mk-header').removeClass('a-sticky');
            }
        }
    }]);

    return DiadaoCommon;
}();

exports.default = DiadaoCommon;

},{}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DiadaoEffect = function () {
    function DiadaoEffect() {
        _classCallCheck(this, DiadaoEffect);
    }

    _createClass(DiadaoEffect, null, [{
        key: 'init',
        value: function init() {
            this.createHoverEffect();
        }
    }, {
        key: 'createHoverEffect',
        value: function createHoverEffect() {
            this.addPlusHover($('.home__visit__item > div'));
            this.addPlusHover($('.offers__card'));
        }
    }, {
        key: 'addPlusHover',
        value: function addPlusHover($elmt) {
            $elmt.append('<div class="hover__plus-pad"><span class="button button__transparent button__plus"><a href="#"><i class="icon-diadao-plus"></i></a></span></div>');
        }
    }]);

    return DiadaoEffect;
}();

exports.default = DiadaoEffect;

},{}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DiadaoFancybox = function () {
    function DiadaoFancybox() {
        _classCallCheck(this, DiadaoFancybox);
    }

    _createClass(DiadaoFancybox, null, [{
        key: 'init',
        value: function init() {
            this.load();
            $('.is-fancybox__action').click(this.open);
        }
    }, {
        key: 'load',
        value: function load() {
            var functions = this;

            $('.is-fancybox').find('.vc_column-inner').each(function () {
                var $this = $(this);

                $this.find('a').click(functions.transformLink($this, $this.find('a')));
                $this.prepend(functions.createLink($this));
            });
        }
    }, {
        key: 'open',
        value: function open() {
            var $this = $(this);

            $this.closest('.is-fancybox').find('.is-fancybox__link').click();
            return false;
        }
    }, {
        key: 'createLink',
        value: function createLink($this) {
            var $image = $this.css('background-image');

            if ($image) {
                var $image_url = $image.replace('url(', '').replace(')', '');

                return '<a href=' + $image_url + ' class="mk-lightbox is-fancybox__link" data-fancybox-group="group-fancybox"></a>';
            }
        }
    }, {
        key: 'transformLink',
        value: function transformLink($this, $item_a) {
            var $image = $this.css('background-image');

            if ($image) {
                var $image_url = $image.replace('url(', '').replace(')', '');
                $item_a.addClass('is-fancybox__action');
                $item_a.attr('id', $image_url);
            }
        }
    }]);

    return DiadaoFancybox;
}();

exports.default = DiadaoFancybox;

},{}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DiadaoForms = function () {
    function DiadaoForms() {
        _classCallCheck(this, DiadaoForms);
    }

    _createClass(DiadaoForms, null, [{
        key: 'init',
        value: function init() {
            this.load();
        }
    }, {
        key: 'load',
        value: function load() {
            var $form = $('.nf-form-cont');
            var this_functions = this;

            if ($form.length) {

                var $verifyFormExists = setInterval(function () {
                    this_functions.applyStyles($form);
                    if ($('nf-field').length) {
                        clearInterval($verifyFormExists);
                    }
                }, 100);
            }
        }
    }, {
        key: 'applyStyles',
        value: function applyStyles($form) {

            $('nf-field').each(function () {
                var $field = $(this);
                var $label = $field.find('.nf-field-label label').text();
                $field.find('input').attr('placeholder', $label);
                $field.find('select').attr('placeholder', $label);
                $field.find('textarea').attr('placeholder', $label);
                $field.find('select').append('<option value="" selected="selected">' + $label + '</option>');
            });

            $form.find('.pikaday__container').prepend('<i class="icon-diadao-calendar-holder"></i>');
            $form.find('.list-wrap').prepend('<i class="icon-diadao-arrow-down"></i>');
        }
    }]);

    return DiadaoForms;
}();

exports.default = DiadaoForms;

},{}],8:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DiadaoLinks = function () {
    function DiadaoLinks() {
        _classCallCheck(this, DiadaoLinks);
    }

    _createClass(DiadaoLinks, null, [{
        key: 'init',
        value: function init() {
            $('.is-link').click(this.openSameWindow);
            $('.is-link__new-window').click(this.openNewWindow);
            this.customLink();
            this.load();
        }
    }, {
        key: 'customLink',
        value: function customLink() {
            var $link = $('.dynamic-booking-link').find('a');
            var $booking_href = $('.header__booking').find('a').attr('href');
            $link.attr('href', $booking_href);
        }
    }, {
        key: 'openSameWindow',
        value: function openSameWindow() {
            var $href = $(this).find('a').attr('href');
            window.location.replace($href);
            return false;
        }
    }, {
        key: 'openNewWindow',
        value: function openNewWindow() {
            var $href = $(this).find('a').attr('href');
            window.open($href);
            return false;
        }
    }, {
        key: 'load',
        value: function load() {
            $('.button__plus').each(function () {
                $(this).find('a').html('<i class="icon-diadao-plus"></i>');
            });
        }
    }]);

    return DiadaoLinks;
}();

exports.default = DiadaoLinks;

},{}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DiadaoMap = function () {
    function DiadaoMap() {
        _classCallCheck(this, DiadaoMap);
    }

    _createClass(DiadaoMap, null, [{
        key: 'init',
        value: function init() {
            this.load();
        }
    }, {
        key: 'load',
        value: function load() {
            if ($('.activities__map').length) {
                this.resize();
            }
        }
    }, {
        key: 'resize',
        value: function resize() {
            var $map = $.bgmp.map;
            var bounds = new google.maps.LatLngBounds();

            if (bgmpData.markers.length > 0) {
                for (var m in bgmpData.markers) {
                    if (bgmpData.markers[m].latitude && bgmpData.markers[m].longitude) {
                        var latlng = new google.maps.LatLng(bgmpData.markers[m].latitude, bgmpData.markers[m].longitude);
                        bounds.extend(latlng);
                    }
                }
            }

            $map.fitBounds(bounds);
        }
    }]);

    return DiadaoMap;
}();

exports.default = DiadaoMap;

},{}],10:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slick = require('./slick');

var _slick2 = _interopRequireDefault(_slick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DiadaoObject = function () {
    function DiadaoObject() {
        _classCallCheck(this, DiadaoObject);
    }

    _createClass(DiadaoObject, null, [{
        key: 'init',
        value: function init() {
            this.load();
            $('.is-object').click(this.open);
            $('.pannel__close-button').click(this.close);
            $('.pannel .pannel__close-background').click(this.close);
            // $('#mk-boxed-layout').click(this.closeAll);
        }
    }, {
        key: 'getPanel',
        value: function getPanel($this) {
            var $object = $this;
            var $object_class = $this.attr('class');
            var $class_array = $object_class.split(' ');

            for (var i = 0; i < $class_array.length; i++) {
                if (!$class_array[i].indexOf('object-')) {
                    var $object_id = $class_array[i];
                    if ($('#' + $object_id + '-item').length) {
                        return $('#' + $object_id + '-item');
                    }
                    return false;
                }
            }
        }
    }, {
        key: 'load',
        value: function load() {
            $('.pannel').each(function () {
                if ($(this).hasClass('pannel__video')) {
                    $(this).find('.height-full').prepend('<div class="pannel__close-button icon-diadao-cross"></div>');
                    $(this).prepend('<div class="pannel__close-background"></div>');
                } else {
                    $(this).prepend('<div class="pannel__close-button icon-diadao-cross"></div>');
                    $(this).attr('style', $(this).attr('style') + '; overflow-y: auto!important');
                }
                $('#mk-theme-container').prepend($(this));
            });
        }
    }, {
        key: 'open',
        value: function open() {
            var $object = $(this);
            var $object_class = $(this).attr('class');
            var $class_array = $object_class.split(' ');

            for (var i = 0; i < $class_array.length; i++) {
                if (!$class_array[i].indexOf('object-')) {
                    var $object_id = $class_array[i];
                    if ($('#' + $object_id + '-item').length) {
                        $('#' + $object_id + '-item').addClass('open');
                        $('body').addClass('hide-overflow');
                        if ($('#' + $object_id + '-item').hasClass('pannel__video')) {
                            $('#mk-theme-container').addClass('very-dark-veil');
                        } else {
                            $('#mk-theme-container').addClass('dark-veil');
                        }
                        if ($('#' + $object_id + '-item').find('.lpslick').length) {
                            _slick2.default.refresh($('#' + $object_id + '-item').find('.lpslick'));
                        }
                    }
                    return false;
                }
            }
        }
    }, {
        key: 'close',
        value: function close() {
            var $pannel = $(this).closest('.pannel');
            var $test_open = 0;

            $pannel.removeClass('open');

            $('.pannel').each(function () {
                if ($(this).hasClass('open')) {
                    $test_open++;
                }
            });
            if ($test_open < 1) {
                $('body').removeClass('hide-overflow');
                $('#mk-theme-container').removeClass('dark-veil');
                $('#mk-theme-container').removeClass('very-dark-veil');
            }
        }

        // static closeAll(){
        //
        //     $('.pannel.open').each(function(){
        //         let $pannel = $(this).closest('.pannel');
        //         let $test_open = 0;
        //
        //         $pannel.removeClass('open');
        //
        //         $('.pannel').each(function(){
        //             if($(this).hasClass('open')){
        //                 $test_open++;
        //             }
        //         })
        //         if($test_open < 1){
        //             $('body').removeClass('hide-overflow');
        //             $('#mk-theme-container').removeClass('dark-veil');
        //         }
        //     })
        // }

    }]);

    return DiadaoObject;
}();

exports.default = DiadaoObject;

},{"./slick":14}],11:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DiadaoOffer = function () {
  function DiadaoOffer() {
    _classCallCheck(this, DiadaoOffer);
  }

  _createClass(DiadaoOffer, null, [{
    key: 'init',
    value: function init() {
      $('.share-buttons').click(this.toggleShare);
      $('.offers__item__share-buttons .background').click(this.toggleShare);
      $('.offers__item__share-buttons .close-button').click(this.toggleShare);
    }
  }, {
    key: 'toggleShare',
    value: function toggleShare() {
      var $this = $(this);
      var $container = $this.closest(".offers__item__share");
      var $buttons_content = $container.find(".offers__item__share-buttons");

      if ($buttons_content.hasClass("open")) {
        $buttons_content.removeClass("open");
        // $("body").removeClass("hide-overflow");
      } else {
        $buttons_content.addClass("open");
        // $("body").addClass("hide-overflow");
      }

      return false;
    }
  }]);

  return DiadaoOffer;
}();

exports.default = DiadaoOffer;

},{}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DiadaoOfferHighlight = function () {
  function DiadaoOfferHighlight() {
    _classCallCheck(this, DiadaoOfferHighlight);
  }

  _createClass(DiadaoOfferHighlight, null, [{
    key: "init",
    value: function init() {
      this.load();
    }
  }, {
    key: "load",
    value: function load() {
      var $offerhighlight = $(".offerhighlight-container");
      if ($offerhighlight.length) {
        var $next_arrow = $offerhighlight.find(".next-slide");
        var $prev_arrow = $offerhighlight.find(".prev-slide");
        if ($next_arrow.length && $prev_arrow.length) {
          $prev_arrow.replaceWith('<i class="next-slide offerhighlight__arrow offerhighlight__arrow__left icon-diadao-arrow-left-small"></i>');
          $next_arrow.replaceWith('<i class="prev-slide offerhighlight__arrow offerhighlight__arrow__right icon-diadao-arrow-right-small"></i>');
        }
      }
    }
  }]);

  return DiadaoOfferHighlight;
}();

exports.default = DiadaoOfferHighlight;

},{}],13:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DiadaoOverlay = function () {
    function DiadaoOverlay() {
        _classCallCheck(this, DiadaoOverlay);
    }

    _createClass(DiadaoOverlay, null, [{
        key: 'init',
        value: function init() {
            this.load();

            var that = this;

            $(window).on('resize', function () {
                that.load();
            });
        }
    }, {
        key: 'load',
        value: function load() {
            if ($(window).width() > 1024) {
                $('.lp-overlay').each(function () {
                    var $container = $(this);
                    var $hidden_content = $container.find('.lp-overlay__hidden');
                    var $hidden_content_height = $hidden_content.outerHeight();

                    if ($hidden_content_height > $container.height()) {
                        $('.lp-overlay > div').css('height', $hidden_content_height);
                    }
                });
                $('.lp-overlay').find('.lp-overlay__hidden').css('display', 'flex');
            } else {
                $('.lp-overlay').find('.lp-overlay__hidden').css('display', 'block');
            }
        }
    }]);

    return DiadaoOverlay;
}();

exports.default = DiadaoOverlay;

},{}],14:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DiadaoSlick = function () {
  function DiadaoSlick() {
    _classCallCheck(this, DiadaoSlick);
  }

  _createClass(DiadaoSlick, null, [{
    key: 'init',
    value: function init() {
      this.offers();
      this.gallery();
    }
  }, {
    key: 'constructor',
    value: function constructor($element, $slides_to_show, $slides_to_scroll, $display_dots) {
      $($element).slick({
        slidesToShow: $slides_to_show,
        slidesToScroll: $slides_to_scroll,
        prevArrow: '<i class="lpslick-arrows lpslick-arrows__left icon-diadao-arrow-left-small"></i>',
        nextArrow: '<i class="lpslick-arrows lpslick-arrows__right icon-diadao-arrow-right-small"></i>',
        dots: $display_dots
      });
    }
  }, {
    key: 'offers',
    value: function offers() {
      var $slides_to_show = 1;

      var $slick_offers = $(".lpslick__offers");
      if ($(window).width() > 1024) {
        if ($slick_offers.hasClass("lpslick__has-2-offers")) {
          $slides_to_show = 2;
        } else if ($slick_offers.hasClass("lpslick__has-1-offers")) {
          $slides_to_show = 1;
        } else {
          $slides_to_show = 3;
        }
      } else if ($(window).width() > 768) {
        if ($slick_offers.hasClass("lpslick__has-1-offers")) {
          $slides_to_show = 1;
        } else {
          $slides_to_show = 2;
        }
      }

      this.constructor(".lpslick__offers", $slides_to_show, $slides_to_show, true);

      if ($slick_offers.find(".slick-dots").length) {
        if ($slick_offers.find(".slick-dots").find("li").length < 2) {
          $slick_offers.find(".slick-dots").remove();
        }
      }
    }
  }, {
    key: 'gallery',
    value: function gallery() {
      this.constructor(".lpslick__gallery", 1, 1, true);
      $(".slick-dots").each(function () {
        if ($(this).find("li").length < 2) {
          $(this).hide();
        }
      });
    }
  }, {
    key: 'refresh',
    value: function refresh($slider_to_refresh) {
      $slider_to_refresh.slick("refresh");
      if ($slider_to_refresh.find(".slick-dots").length) {
        if ($slider_to_refresh.find(".slick-dots").find("li").length < 2) {
          $slider_to_refresh.find(".slick-dots").hide();
        }
      }
    }
  }]);

  return DiadaoSlick;
}();

exports.default = DiadaoSlick;

},{}],15:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DiadaoSliderRevolution = function () {
    function DiadaoSliderRevolution() {
        _classCallCheck(this, DiadaoSliderRevolution);
    }

    _createClass(DiadaoSliderRevolution, null, [{
        key: 'init',
        value: function init() {
            this.load();
        }
    }, {
        key: 'load',
        value: function load() {
            this.verifySlidesNumber();
        }
    }, {
        key: 'verifySlidesNumber',
        value: function verifySlidesNumber() {
            $('.slideshow').each(function () {
                var $slideshow = $(this);
                var $bullets_container = $slideshow.find('.tp-bullets');
                var $bullets_number = $bullets_container.find('.tp-bullet').length;

                if ($bullets_number < 2) {
                    $slideshow.addClass('hide-controllers');
                }
            });
        }
    }]);

    return DiadaoSliderRevolution;
}();

exports.default = DiadaoSliderRevolution;

},{}],16:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _object = require('./object');

var _object2 = _interopRequireDefault(_object);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DiadaoVideo = function () {
    function DiadaoVideo() {
        _classCallCheck(this, DiadaoVideo);
    }

    _createClass(DiadaoVideo, null, [{
        key: 'init',
        value: function init() {
            var that = this;

            $('.is-object__video').on('click', function (e) {
                that.play(e.currentTarget);
            });

            $('.pannel__video .pannel__close-button').on('click', function (e) {
                that.stop(e.currentTarget);
            });
        }
    }, {
        key: 'getNewIframe',
        value: function getNewIframe($video_src, $width, $height) {

            var regexp = new RegExp("^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:youtu\.be\/|youtube\.com\/(?:(?:watch)?\?(?:.*&)?v(?:i)?=|(?:embed|v|vi|user)\/))([^\?&\"'>]+)");
            var urlParameters = regexp.exec($video_src);
            var $new_href = 'https://youtube.com/embed/' + urlParameters[1] + '?autoplay=true&rel=0&showinfo=0';

            var $iframe_html = '<iframe style="width: ' + $width + 'px; height: ' + $height + 'px" class="lp-video" src="' + $new_href + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';

            return $iframe_html;
        }
    }, {
        key: 'play',
        value: function play(target) {
            var $panel = _object2.default.getPanel($(target));
            var $content = $panel.find('.height-full');
            var $video = $panel.find('iframe');
            var $video_src = $video.attr('src');
            var $iframe_html = this.getNewIframe($video_src, $content.width(), $content.height());

            $video.hide();
            $video.closest('.video-player').append($iframe_html);
        }
    }, {
        key: 'stop',
        value: function stop(target) {
            $(target).closest('.pannel').find('.lp-video').remove();
        }
    }]);

    return DiadaoVideo;
}();

exports.default = DiadaoVideo;

},{"./object":10}]},{},[3]);
